import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8080';

const authHeaders = (accessToken) => ({ Authorization: `Bearer ${accessToken}` });

// ── Types de tarif suggérés (libre en base, extensible sans changement de code) ──
export const PRICING_PLAN_TYPES = [
    { value: 'fixed', label: 'Prix fixe' },
    { value: 'tiered', label: 'Palier' },
    { value: 'volume_grid', label: 'Grille tarifaire' },
    { value: 'percentage_discount', label: 'Remise en %' },
    { value: 'fixed_discount', label: 'Remise montant fixe' },
    { value: 'time_limited_discount', label: 'Remise sur période définie' },
    { value: 'subscription', label: 'Abonnement récurrent' },
    { value: 'usage_based', label: 'Tarification à l\'usage' },
    { value: 'bundle', label: 'Pack' },
    { value: 'quote', label: 'Sur devis (sans prix, contact commercial)' },
    { value: 'included', label: 'Offert avec le compte Alaïs-Studio (gratuit)' },
    { value: 'custom', label: 'Autre / personnalisé' },
];

// ── Options ────────────────────────────────────────────────────────────────

export async function getOptions(accessToken, applicationId) {
    const res = await axios.get(`${API_URL}/api/options`, {
        headers: authHeaders(accessToken),
        params: { application_id: applicationId }
    });
    return res.data;
}

export async function createOption(accessToken, data) {
    const res = await axios.post(`${API_URL}/api/options`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function updateOption(accessToken, id, data) {
    const res = await axios.put(`${API_URL}/api/options/${id}`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function deleteOption(accessToken, id) {
    const res = await axios.delete(`${API_URL}/api/options/${id}`, { headers: authHeaders(accessToken) });
    return res.data;
}

// ── Permissions (catalogue key/name/description d'une application) ──────────

export async function getPermissions(accessToken, applicationId) {
    const res = await axios.get(`${API_URL}/api/permissions`, {
        headers: authHeaders(accessToken),
        params: { application_id: applicationId }
    });
    return res.data;
}

export async function createPermission(accessToken, data) {
    const res = await axios.post(`${API_URL}/api/permissions`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function updatePermission(accessToken, id, data) {
    const res = await axios.put(`${API_URL}/api/permissions/${id}`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function deletePermission(accessToken, id) {
    const res = await axios.delete(`${API_URL}/api/permissions/${id}`, { headers: authHeaders(accessToken) });
    return res.data;
}

// ── Plans tarifaires ─────────────────────────────────────────────────────────

export async function getPricingPlans(accessToken, priceableType, priceableId) {
    const res = await axios.get(`${API_URL}/api/pricing-plans`, {
        headers: authHeaders(accessToken),
        params: { priceable_type: priceableType, priceable_id: priceableId }
    });
    return res.data;
}

export async function createPricingPlan(accessToken, data) {
    const res = await axios.post(`${API_URL}/api/pricing-plans`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function updatePricingPlan(accessToken, id, data) {
    const res = await axios.put(`${API_URL}/api/pricing-plans/${id}`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function deletePricingPlan(accessToken, id) {
    const res = await axios.delete(`${API_URL}/api/pricing-plans/${id}`, { headers: authHeaders(accessToken) });
    return res.data;
}

// ── Paliers / grille tarifaire ─────────────────────────────────────────────

export async function createPricingTier(accessToken, planId, data) {
    const res = await axios.post(`${API_URL}/api/pricing-plans/${planId}/tiers`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function updatePricingTier(accessToken, planId, tierId, data) {
    const res = await axios.put(`${API_URL}/api/pricing-plans/${planId}/tiers/${tierId}`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function deletePricingTier(accessToken, planId, tierId) {
    const res = await axios.delete(`${API_URL}/api/pricing-plans/${planId}/tiers/${tierId}`, { headers: authHeaders(accessToken) });
    return res.data;
}

// ── Codes promo ──────────────────────────────────────────────────────────────

export async function getPromoCodes(accessToken, pricingPlanId) {
    const res = await axios.get(`${API_URL}/api/promo-codes`, {
        headers: authHeaders(accessToken),
        params: pricingPlanId !== undefined ? { pricing_plan_id: pricingPlanId } : {}
    });
    return res.data;
}

export async function createPromoCode(accessToken, data) {
    const res = await axios.post(`${API_URL}/api/promo-codes`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function updatePromoCode(accessToken, id, data) {
    const res = await axios.put(`${API_URL}/api/promo-codes/${id}`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function deletePromoCode(accessToken, id) {
    const res = await axios.delete(`${API_URL}/api/promo-codes/${id}`, { headers: authHeaders(accessToken) });
    return res.data;
}
